<template>
  <div>
    <div class="card">
      <div class="card-body">
        <Filtro @loteImportacaoAstecFiltrados="atualizarFiltro" />
      </div>
    </div>
    <div>
      <div class="text-center" v-if="loadingGridImportacao === true">
        <b-spinner class="ms-2" variant="primary"></b-spinner>
      </div>
      <div class="card" v-if="loadingGridImportacao === false">
        <div class="card-body">
          <Grid
            :items="lotesImportadosListados"
            @loteImportacaoAstecFiltrados="atualizarFiltro"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Filtro from "@/components/astec/loteImportacao/filtro";
import Grid from "@/components/astec/loteImportacao/gridLoteImportacao";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";

export default {
  mixins: [clienteRuralMixin],
  components: {
    Grid,
    Filtro,
  },

  data() {
    return {
      filtro: {},
      loadingGridImportacao: null,
      lotesImportadosListados: [],
    };
  },

  methods: {
    async atualizarFiltro(callback) {
      this.loadingGridImportacao = true;
      this.lotesImportadosListados = [];
      this.loadingGridImportacao = false;
      if (typeof callback === "function") callback();
    },
  },
};
</script>
